<template>
  <div class="relative">
    <slot></slot>
    <div v-if="show" class="absolute top-0 left-0 w-full h-full bg-white flex items-center justify-center z-10" :style="{ opacity: opacity, borderRadius: 'inherit' }">
      <div class="overlay-spinner inline-block w-8 h-8 border-3 border-border border-t-primary rounded-full"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseOverlay',
  props: {
    show: { type: Boolean, default: false },
    opacity: { type: [Number, String], default: 0.85 }
  }
}
</script>

<style scoped>
.overlay-spinner {
  animation: overlay-spin 0.6s linear infinite;
}

@keyframes overlay-spin {
  to { transform: rotate(360deg); }
}
</style>
